module.exports = __webpack_public_path__ + "img/logo44.4a6973da.jpg";